import BaseHandler from "../BaseHandler";
import { StoryGetOwnStoryViewsResponse } from "../../proto/StoryGetOwnStoryViews_pb";
import { addStoryView, updateStoryView } from "../../store/stories/actions";
import store from "../../store";
import { getUser } from "../../libs/hooks";
import { addUsers } from "../../store/users/actions";

export default class HandleStoryGetOwnStoryViewsResponse extends BaseHandler<StoryGetOwnStoryViewsResponse> {
  handle() {
    const getOwnStoryViewsResponse = this.response.toObject();

    if (getOwnStoryViewsResponse.groupedViewsList) {
      store.dispatch(addStoryView(getOwnStoryViewsResponse.groupedViewsList));
    }
  }
}
